'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _PromoBlockItem = require('./PromoBlockItem/PromoBlockItem');var _PromoBlockItem2 = _interopRequireDefault(_PromoBlockItem);

var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);

var _promoBlock = require('./promoBlock.scss');var styles = _interopRequireWildcard(_promoBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers

var PromoBlock = function PromoBlock(props) {
  var renderPromoItems = function renderPromoItems(item, idx) {var _getLocalizedData =
    (0, _getLocalizedData3.default)(item.description, props.locale),description = _getLocalizedData.result;
    return (
      _react2.default.createElement(_PromoBlockItem2.default, {
        contentText: description,
        key: 'company_promo_description_' + idx }));


  };

  return (
    _react2.default.createElement('div', { className: styles.promoWrap },
      _react2.default.createElement('div', { className: styles.title }, props.title),
      _react2.default.createElement('div', { className: styles.promoBlock },
        props.advantages.map(renderPromoItems))));



}; // Styles
// Components
// Modules
PromoBlock.propTypes = { title: _propTypes2.default.func,
  advantages: _propTypes2.default.array,
  locale: _propTypes2.default.string };exports.default =


PromoBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PromoBlock/PromoBlock.js
// module id = 2822
// module chunks = 0